var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDotnet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 184 40",
    style: {
      enableBackground: "new 0 0 184 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:#14559A;}\n\t.st3{fill:url(#SVGID_3_);}\n\t.st4{fill:#3092C4;}\n\t.st5{fill:#1969BC;}\n\t.st6{fill:url(#SVGID_4_);}\n\t.st7{fill:url(#SVGID_5_);}\n\t.st8{fill:url(#SVGID_6_);}\n\t.st9{fill:#2B74B1;}\n\t.st10{fill:#125A9E;}\n\t.st11{fill:url(#SVGID_7_);}\n\t.st12{fill:url(#SVGID_8_);}\n\t.st13{fill:#0D82CA;}\n\t.st14{fill:url(#SVGID_9_);}\n\t.st15{fill:#127BCA;}\n\t.st16{fill:url(#SVGID_10_);}\n\t.st17{fill:url(#SVGID_11_);}\n\t.st18{fill:#05A1E6;}\n\t.st19{fill:url(#SVGID_12_);}\n\t.st20{fill:url(#SVGID_13_);}\n\t.st21{fill:url(#SVGID_14_);}\n\t.st22{fill:#079AE1;}\n\t.st23{fill:#1E5CB3;}\n\t.st24{fill:#1D60B5;}\n\t.st25{fill:#175FAB;}\n\t.st26{fill:url(#SVGID_15_);}\n\t.st27{fill:#7DCBEC;}\n\t.st28{fill:#5EC5ED;}\n\t.st29{fill:url(#SVGID_16_);}\n\t.st30{fill:url(#SVGID_17_);}\n\t.st31{fill:url(#SVGID_18_);}\n\t.st32{fill:#2C5FA2;}\n")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.810127, 0.000000)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -3791.752,
    y1: -53.5807,
    x2: -3791.752,
    y2: -53.051,
    gradientTransform: "matrix(45.6076 0 0 81.335 172972.2656 4361.5586)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0994DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#66CEF5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#66CEF5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8462,
    style: {
      stopColor: "#127BCA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8462,
    style: {
      stopColor: "#127BCA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#127BCA"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.5,10.4c3.3,9.9,4.5,27.7,14,27.7l0,0c0.7,0,1.5-0.1,2.2-0.2l0,0c-8.7-2-9.7-19.6-15-28.7l0,0 C32.3,9.6,31.9,10,31.5,10.4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -3795.751,
    y1: -54.7648,
    x2: -3795.751,
    y2: -54.2352,
    gradientTransform: "matrix(47.8692 0 0 83.4083 181740.7656 4570.3008)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0E76BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#36AEE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#36AEE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8462,
    style: {
      stopColor: "#00ADEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8462,
    style: {
      stopColor: "#00ADEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00ADEF"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.7,9.2c5.3,9.1,6.3,26.7,15,28.7l0,0c0.7-0.1,1.3-0.3,2.1-0.6l0,0c-7.8-3.8-9.9-20.8-15.9-29l0,0 C33.4,8.6,33,8.9,32.7,9.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M40.3,3.8c-0.7,0-1.5,0.1-2.2,0.2c-1.9,0.4-3.9,1.2-5.9,2.5c0.5,0.5,1.1,1.1,1.5,1.8c2-1.7,4-2.9,6-3.6 C40.5,4.4,41.2,4.1,42,4C41.5,3.9,40.9,3.8,40.3,3.8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -3791.8884,
    y1: -54.8178,
    x2: -3791.8884,
    y2: -55.2338,
    gradientTransform: "matrix(45.4522 0 0 84.5 172399.7344 4669.2188)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C63B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#33BDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#33BDF2",
      stopOpacity: 0.4196
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M55.7,33.8c0.8-0.6,1.6-1.3,2.4-2.1c-3.3-9.9-4.5-27.9-14.1-27.9c-0.7,0-1.4,0.1-2.1,0.2 C50.7,6.2,51.8,25.2,55.7,33.8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M42,4c-0.5-0.1-1.1-0.2-1.7-0.2h3.8C43.4,3.8,42.7,3.9,42,4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M55.6,35.9c-0.4-0.4-0.7-0.7-1.1-1.2c-1.6,1.1-3.2,2-4.8,2.6c0.6,0.3,1.2,0.5,1.8,0.6c0.5,0.1,1,0.1,1.5,0.1 c1.8,0,3.2-0.2,4.4-0.8C56.8,37,56.2,36.5,55.6,35.9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -3790.9788,
    y1: -56.4192,
    x2: -3790.9788,
    y2: -55.8896,
    gradientTransform: "matrix(45.0105 0 0 86.5982 170681.6094 4883.8442)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#166AB8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#36AEE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#36AEE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8462,
    style: {
      stopColor: "#0798DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8462,
    style: {
      stopColor: "#0798DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0798DD"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M39.8,4.6c7.8,4.1,8.5,22.6,14.7,30.1l0,0c0.4-0.3,0.8-0.6,1.2-0.9l0,0C51.8,25.2,50.7,6.2,42,4l0,0 C41.3,4.1,40.5,4.4,39.8,4.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: -3810.1013,
    y1: -59.15,
    x2: -3810.1013,
    y2: -58.6204,
    gradientTransform: "matrix(58.3509 0 0 92.0822 222367 5444.9302)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#124379"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#1487CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#1487CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7802,
    style: {
      stopColor: "#165197"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7802,
    style: {
      stopColor: "#165197"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#165197"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M33.8,8.3c6,8.2,8.1,25.2,15.9,29.1l0,0c1.6-0.6,3.2-1.4,4.8-2.6l0,0c-6.3-7.6-7-26.1-14.8-30.2l0,0 C37.8,5.4,35.8,6.6,33.8,8.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: -3678.4036,
    y1: 25.8071,
    x2: -3678.0486,
    y2: 25.8071,
    gradientTransform: "matrix(19.4176 0 0 30.9219 71450.3281 -784.7935)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#33BDF2",
      stopOpacity: 0.698
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1DACD8"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M27.6,10.1c-0.9,2.1-1.9,4.9-3.1,8.6c2.3-3.3,4.6-6,6.9-8.3c-0.3-1-0.6-1.8-1-2.7C29.5,8.4,28.5,9.3,27.6,10.1 "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M31.3,7.1c-0.3,0.2-0.6,0.4-0.8,0.6c0.4,0.8,0.7,1.7,1,2.7c0.4-0.4,0.8-0.8,1.2-1.2 C32.2,8.4,31.8,7.8,31.3,7.1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M32.3,6.4c-0.3,0.2-0.6,0.4-1,0.6c0.5,0.6,1,1.3,1.4,2.1c0.4-0.3,0.7-0.6,1.1-1C33.3,7.6,32.8,7,32.3,6.4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: -3827.9207,
    y1: -61.5835,
    x2: -3827.9207,
    y2: -61.9305,
    gradientTransform: "matrix(79.1425 0 0 98.6787 303027.5938 6113.1846)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#136AB4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#59CAF5",
      stopOpacity: 0.549
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#59CAF5",
      stopOpacity: 0.2353
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M85.6,3c-4.4,17-13.7,30.8-21.4,34.2l0,0c-0.1,0.1-0.3,0.1-0.4,0.2c0,0,0,0,0,0c0,0-0.1,0-0.1,0 c0,0,0,0-0.1,0c-0.1,0-0.1,0-0.2,0.1c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0s-0.1,0-0.1,0s-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0c0,0,0,0-0.1,0 c0,0-0.1,0-0.1,0s0,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0.4,0.1,0.7,0.2,1.1,0.2c7.4,0,14.7-13.2,27-35.1L85.6,3L85.6,3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: -3821.8328,
    y1: -61.9499,
    x2: -3821.4778,
    y2: -61.9499,
    gradientTransform: "matrix(72.0226 0 0 99.1613 275258.375 6164.5347)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#05A1E6",
      stopOpacity: 0.2471
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#05A1E6"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M23,4.5L23,4.5C23,4.5,23,4.5,23,4.5L23,4.5c0.1,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0h0c0,0,0.1,0,0.1,0l0,0 c0.1,0,0.2-0.1,0.3-0.1h0c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0s0.1,0,0.1,0h0c0.1,0,0.3-0.1,0.4-0.1c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0 c0,0,0,0,0.1,0s0.1,0,0.1,0h0c0.1,0,0.2,0,0.2,0h0c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0.1,0,0.2,0,0.2,0 c-0.2,0-0.5,0-0.8,0c-8.3,0-19.7,15.3-24.8,35.2h1c1.6-2.9,3.1-5.7,4.5-8.3C9.1,16.6,16.5,7,23,4.5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M27.6,10.1c0.9-0.9,1.9-1.7,2.8-2.4c-0.2-0.5-0.4-0.9-0.7-1.3C29,7.3,28.3,8.5,27.6,10.1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M28.3,4.6c0.5,0.5,1,1.1,1.5,1.8c0.1-0.2,0.3-0.3,0.4-0.5c-0.6-0.6-1.3-1-2-1.4C28.2,4.6,28.3,4.6,28.3,4.6 L28.3,4.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: -3796.6682,
    y1: -48.0193,
    x2: -3796.6682,
    y2: -48.4943,
    gradientTransform: "matrix(49.0511 0 0 73.8222 186245.0156 3581.9839)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#318ED5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#38A7E4"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M5.5,30.7C13.1,16.2,16.6,7,23,4.5l0,0C16.5,7.1,9.1,16.6,5.5,30.7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M30.2,5.9c-0.1,0.1-0.3,0.3-0.4,0.5c0.2,0.4,0.5,0.8,0.7,1.3c0.3-0.2,0.6-0.4,0.8-0.6 C30.9,6.7,30.6,6.3,30.2,5.9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: -3790.8247,
    y1: -32.9443,
    x2: -3790.8247,
    y2: -33.5409,
    gradientTransform: "matrix(45.6036 0 0 57.1283 172891.6875 1919.29)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#05A1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#05A1E6",
      stopOpacity: 0.549
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M9,38.9L9,38.9c0,0-0.1,0-0.1,0h0c0,0-0.1,0-0.1,0h0c-0.1,0-0.2,0-0.3,0h0c7.6-0.2,11.1-4,12.9-9.6 c1.3-4.2,2.4-7.7,3.3-10.7c-3.2,4.5-6.4,9.9-9.6,15.9C13.4,37.5,11,38.7,9,38.9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: -3801.9883,
    y1: -53.0325,
    x2: -3801.9883,
    y2: -53.3876,
    gradientTransform: "matrix(52.5191 0 0 81.0936 199695.2969 4339.5347)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1959A6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#05A1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#05A1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9176,
    style: {
      stopColor: "#7EC5EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7EC5EA"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M9,38.9L9,38.9c2-0.2,4.4-1.5,6-4.4l0,0c3.2-6,6.4-11.4,9.6-15.9l0,0c1.1-3.7,2.1-6.4,3.1-8.6l0,0 C21.3,16.2,14.9,26.3,9,38.9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M5.5,30.7c-1.3,2.6-2.8,5.4-4.4,8.3H4C4.3,36.1,4.9,33.3,5.5,30.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: -3822.2014,
    y1: -61.7309,
    x2: -3822.2771,
    y2: -62.0463,
    gradientTransform: "matrix(72.6768 0 0 99.0047 277804.7813 6148.7295)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#165096"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0D82CA"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M25.4,3.9C25.4,3.9,25.4,3.9,25.4,3.9L25.4,3.9c-0.1,0-0.1,0-0.2,0l0,0c0,0,0,0-0.1,0l0,0c0,0-0.1,0-0.1,0 l0,0h0l0,0c-0.1,0-0.2,0-0.2,0l0,0h0l0,0c0,0-0.1,0-0.1,0l0,0c0,0,0,0-0.1,0l0,0c0,0-0.1,0-0.1,0l0,0c0,0,0,0-0.1,0l0,0 c-0.1,0-0.3,0.1-0.4,0.1l0,0h0l0,0c0,0-0.1,0-0.1,0l0,0c0,0,0,0-0.1,0l0,0c0,0-0.1,0-0.1,0l0,0h0l0,0c-0.1,0-0.2,0.1-0.3,0.1l0,0 l0,0l0,0c0,0-0.1,0-0.1,0l0,0c0,0,0,0-0.1,0l0,0c0,0-0.1,0-0.1,0l0,0c0,0,0,0,0,0l0,0c-6.3,2.5-9.9,11.7-17.4,26.2l0,0 C4.9,33.3,4.4,36,4,38.9l0,0h0.4c1.1,0,1.5,0,2.8,0l0,0h0.1h0.2h0.1h0h0.1h0h0h0h0.2H8h0.1h0h0.2l0,0c0.1,0,0.2,0,0.3,0l0,0l0,0 l0,0c0,0,0.1,0,0.1,0l0,0h0l0,0c0,0,0.1,0,0.1,0l0,0c5.9-12.7,12.3-22.7,18.6-28.8l0,0c0.7-1.6,1.4-2.8,2.1-3.7l0,0 c-0.4-0.7-0.9-1.4-1.5-1.8l0,0l0,0l0,0c0,0-0.1,0-0.1,0l0,0c0,0-0.1,0-0.1,0l0,0c0,0-0.1,0-0.1,0l0,0c0,0-0.1,0-0.1,0l0,0 c0,0,0,0-0.1,0l0,0c-0.1,0-0.1,0-0.2-0.1l0,0c0,0,0,0-0.1,0l0,0c0,0-0.1,0-0.1,0l0,0c0,0,0,0-0.1,0l0,0c-0.1,0-0.1,0-0.2-0.1l0,0 l0,0l0,0c-0.1,0-0.2,0-0.2,0l0,0h0l0,0c-0.1,0-0.1,0-0.2,0l0,0h0l0,0C26.6,4,26.5,4,26.3,4l0,0h0l0,0c-0.1,0-0.1,0-0.2,0l0,0h0l0,0 c-0.1,0-0.1,0-0.2,0l0,0h0l0,0c-0.1,0-0.1,0-0.2,0l0,0C25.6,3.9,25.5,3.9,25.4,3.9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: -3760.793,
    y1: -32.6389,
    x2: -3760.793,
    y2: -32.924,
    gradientTransform: "matrix(32.7663 0 0 57.2261 123297.75 1887.2596)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#05A1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8736,
    style: {
      stopColor: "#0495D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0495D6"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M68.3,12.5c-1.5,4.7-2.6,8.5-3.7,11.6l0,0c4-5.5,7.9-12.4,11.6-20.3l0,0C71.9,5.2,69.6,8.3,68.3,12.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: -3813.0439,
    y1: -60.9546,
    x2: -3813.1541,
    y2: -60.564,
    gradientTransform: "matrix(60.2691 0 0 96.3231 229886.875 5872.9336)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#38A7E4",
      stopOpacity: 0.3294
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9615,
    style: {
      stopColor: "#0E88D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9615,
    style: {
      stopColor: "#0E88D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0E88D3"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M64.8,37c-0.2,0.1-0.4,0.2-0.6,0.3c7.7-3.4,17-17.2,21.4-34.2h-0.9C74.5,21.2,71.3,33.3,64.8,37"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M59.7,35.4c1.7-2.1,3.1-5.5,4.9-11.3c-2.2,3-4.3,5.5-6.5,7.6c0,0,0,0,0,0C58.6,33.2,59.2,34.4,59.7,35.4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M59.7,35.4c-0.6,0.7-1.2,1.2-1.8,1.6c-0.1,0.1-0.3,0.2-0.5,0.2c0.7,0.4,1.5,0.6,2.4,0.7l0,0c0.1,0,0.2,0,0.4,0 h0c0.1,0,0.1,0,0.2,0h0h0.2h0.2h0.1H61c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0l0,0h0c0,0,0.1,0,0.1,0l0,0h0c0.1,0,0.1,0,0.2,0h0 c0.1,0,0.1,0,0.2,0l0,0l0,0c0.1,0,0.2,0,0.4-0.1C61.3,37.6,60.5,36.7,59.7,35.4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M45.4,38.1c0.7,0,1.5-0.1,2.2-0.2c0.7-0.1,1.3-0.3,2.1-0.6c0.6,0.3,1.2,0.5,1.8,0.6c0.5,0.1,1,0.1,1.5,0.1 L45.4,38.1L45.4,38.1z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M53,38.1c1.8,0,3.2-0.2,4.4-0.8c0.7,0.4,1.5,0.6,2.4,0.7l0,0c0.1,0,0.2,0,0.4,0h0c0.1,0,0.1,0,0.2,0h0h0.2H53 L53,38.1z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M60.6,38.1h0.2h0.1H61c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0l0,0h0.1c0,0,0.1,0,0.1,0l0,0h0c0.1,0,0.1,0,0.2,0h0 c0.1,0,0.1,0,0.2,0l0,0l0,0c0.1,0,0.2,0,0.4-0.1l0,0c0.4,0.1,0.7,0.2,1.1,0.2L60.6,38.1L60.6,38.1z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M58.2,31.7L58.2,31.7c-0.8,0.7-1.6,1.5-2.4,2.1c-0.4,0.3-0.8,0.6-1.2,0.9c0.4,0.4,0.7,0.8,1.1,1.2 c0.6,0.6,1.2,1,1.8,1.4c0.1-0.1,0.3-0.1,0.5-0.2c0.7-0.4,1.3-0.9,1.8-1.6C59.2,34.4,58.6,33.2,58.2,31.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: -3821.8628,
    y1: -61.6885,
    x2: -3821.8628,
    y2: -61.3256,
    gradientTransform: "matrix(70.2816 0 0 98.1105 268678.8125 6055.1953)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#168CD4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#1C87CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#154B8D"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M81.8,3h-3.8h-0.4l0,0h-0.4l0,0l0,0c-0.2,0-0.5,0-0.7,0l0,0c-0.1,0.2-0.2,0.5-0.3,0.7l0,0 c-3.7,8-7.7,14.8-11.6,20.3l0,0c-1.9,5.8-3.2,9.3-4.9,11.3l0,0c0.7,1.2,1.6,2.1,2.6,2.5l0,0c0,0,0,0,0.1,0l0,0l0,0l0,0 c0,0,0,0,0.1,0l0,0c0,0,0.1,0,0.1,0l0,0c0,0,0,0,0.1,0l0,0c0,0,0.1,0,0.1,0l0,0c0,0,0,0,0.1,0l0,0c0.1,0,0.1,0,0.2,0l0,0 c0,0,0.1,0,0.1,0l0,0c0,0,0.1,0,0.1,0l0,0c0,0,0.1,0,0.1,0l0,0c0,0,0.1,0,0.1,0l0,0c0.1,0,0.1,0,0.2-0.1l0,0c0,0,0,0,0.1,0l0,0 c0,0,0.1,0,0.1,0l0,0c0,0,0,0,0,0l0,0c0.1-0.1,0.3-0.1,0.4-0.2l0,0l0,0l0,0c0.2-0.1,0.4-0.2,0.6-0.3l0,0 c6.5-3.6,9.7-15.8,19.9-33.9l0,0L81.8,3L81.8,3z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M25.7,3.9L25.7,3.9c0.1,0,0.1,0,0.1,0h0c0.1,0,0.1,0,0.2,0h0c0.1,0,0.1,0,0.2,0h0C26.4,4,26.6,4,26.7,4h0 c0.1,0,0.1,0,0.2,0h0c0.1,0,0.1,0,0.2,0.1l0,0c0.1,0,0.1,0,0.2,0.1c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0 c0.1,0,0.1,0,0.2,0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.7,0.4,1.4,0.8,2,1.4 c0.2-0.2,0.5-0.5,0.7-0.6c-1.3-1-2.9-1.5-4.6-1.5C26.1,3.8,25.9,3.9,25.7,3.9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M30.2,5.9c0.4,0.4,0.7,0.7,1.1,1.2c0.3-0.2,0.6-0.5,1-0.6c-0.4-0.4-0.9-0.8-1.3-1.1 C30.6,5.5,30.4,5.7,30.2,5.9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: -3757.6084,
    y1: -1031.1046,
    x2: -3757.3557,
    y2: -1031.905,
    gradientTransform: "matrix(32.4594 0 0 -4.2491 121996.3984 -4379.0845)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#97D6EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7033,
    style: {
      stopColor: "#55C1EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#55C1EA"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M25.7,3.9c0.2,0,0.4,0,0.6,0c1.7,0,3.3,0.5,4.6,1.5c1.4-1.1,3.1-1.5,5.5-1.5H24.9C25.1,3.8,25.4,3.8,25.7,3.9 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: -3731.3716,
    y1: -629.6198,
    x2: -3731.127,
    y2: -629.2275,
    gradientTransform: "matrix(26.4722 0 0 -7.484 98809.1719 -4705.8145)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7ACCEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3FB7ED"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M36.4,3.8c-2.4,0-4.1,0.4-5.5,1.5c0.5,0.3,0.9,0.7,1.3,1.1c2-1.2,3.9-2.1,5.9-2.5c0.7-0.1,1.5-0.2,2.2-0.2 L36.4,3.8L36.4,3.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: -3803.0344,
    y1: -52.931,
    x2: -3803.0344,
    y2: -52.4992,
    gradientTransform: "matrix(52.0449 0 0 80.6355 197995.9375 4273.0605)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1DA7E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#37ABE7",
      stopOpacity: 0
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M64.7,24.1c1-3.2,2.2-7,3.7-11.6c1.3-4.2,3.6-7.3,8-8.7c0.1-0.2,0.2-0.5,0.3-0.7c-7.1,0.4-10.4,4-12.1,9.4 c-2.9,9.3-4.7,15.4-6.4,19.2C60.3,29.6,62.5,27.1,64.7,24.1"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M75.1,35.6h-0.8v2.5H74v-2.5h-0.8v-0.3h2V35.6L75.1,35.6z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M78.4,38.1H78v-1.9c0-0.1,0-0.3,0-0.5l0,0c0,0.1-0.1,0.2-0.1,0.3l-1,2.2h-0.1l-1-2.1c0-0.1-0.1-0.1-0.1-0.3 l0,0c0,0.1,0,0.3,0,0.5v1.9h-0.3v-2.8H76l0.9,2c0.1,0.1,0.1,0.2,0.1,0.3l0,0c0.1-0.1,0.1-0.3,0.1-0.4l0.9-2h0.4L78.4,38.1 L78.4,38.1z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.734177, 116.658228)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M128.5-110.4c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.2-0.1-0.4-0.1h-0.3v0.8h0.3C128.3-110,128.5-110.1,128.5-110.4 L128.5-110.4z M128.9-108.7h-0.4l-0.2-0.5c-0.1-0.3-0.3-0.4-0.4-0.4h-0.2v0.9h-0.3v-2.3h0.6c0.3,0,0.5,0.1,0.6,0.2 c0.1,0.1,0.2,0.2,0.2,0.4c0,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.2,0.2-0.4,0.2l0,0c0.1,0,0.2,0.2,0.4,0.4L128.9-108.7L128.9-108.7z  M129.6-109.9c0-0.5-0.2-0.8-0.5-1.1c-0.3-0.3-0.7-0.5-1.1-0.5s-0.8,0.2-1.1,0.5c-0.3,0.3-0.5,0.7-0.5,1.1c0,0.5,0.2,0.8,0.5,1.1 c0.3,0.3,0.7,0.5,1.1,0.5c0.4,0,0.8-0.2,1.1-0.5C129.5-109,129.6-109.4,129.6-109.9L129.6-109.9z M129.8-109.9 c0,0.5-0.2,0.9-0.5,1.3c-0.3,0.3-0.8,0.5-1.3,0.5c-0.5,0-0.9-0.2-1.3-0.5c-0.3-0.3-0.5-0.8-0.5-1.3c0-0.5,0.2-0.9,0.5-1.3 c0.3-0.3,0.8-0.5,1.3-0.5c0.5,0,0.9,0.2,1.3,0.5C129.7-110.8,129.8-110.4,129.8-109.9L129.8-109.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M81.4-103.6h-1.1v-6.3c0-0.5,0-1.1,0.1-1.8h0c-0.1,0.4-0.2,0.7-0.3,0.9l-3.2,7.2h-0.5l-3.2-7.1 c-0.1-0.2-0.2-0.5-0.3-1l0,0c0,0.4,0,1,0,1.8v6.3h-1.1v-9.4h1.5l2.9,6.5c0.2,0.5,0.4,0.9,0.4,1.1h0.1c0.2-0.5,0.3-0.9,0.5-1.2 l2.9-6.5h1.4V-103.6L81.4-103.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M84.7-103.6h-1.1v-6.7h1.1V-103.6L84.7-103.6z M84.9-112.6c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2 c-0.2,0-0.4-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.5c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2 C84.8-113,84.9-112.8,84.9-112.6L84.9-112.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M91.4-103.9c-0.5,0.3-1.1,0.5-1.8,0.5c-1,0-1.7-0.3-2.3-0.9c-0.6-0.6-0.8-1.4-0.8-2.4c0-1.1,0.3-2,0.9-2.7 c0.6-0.7,1.5-1,2.5-1c0.6,0,1.1,0.1,1.5,0.3v1.1c-0.5-0.4-1-0.5-1.6-0.5c-0.7,0-1.2,0.2-1.7,0.7c-0.5,0.5-0.7,1.1-0.7,1.9 c0,0.8,0.2,1.4,0.6,1.8c0.4,0.5,1,0.7,1.7,0.7c0.6,0,1.1-0.2,1.6-0.6V-103.9L91.4-103.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M96.5-109.2c-0.2-0.2-0.5-0.2-0.8-0.2c-0.4,0-0.8,0.2-1.1,0.6c-0.3,0.4-0.5,1.1-0.5,1.8v3.4H93v-6.7h1.1v1.4 h0c0.2-0.5,0.4-0.9,0.7-1.1c0.3-0.2,0.6-0.4,1-0.4c0.3,0,0.5,0,0.6,0.1V-109.2L96.5-109.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M102.5-106.9c0-0.8-0.2-1.5-0.6-2c-0.4-0.4-0.9-0.6-1.6-0.6s-1.2,0.2-1.6,0.7c-0.4,0.5-0.6,1.1-0.6,2 c0,0.8,0.2,1.4,0.6,1.9c0.4,0.5,0.9,0.7,1.6,0.7s1.2-0.2,1.6-0.7C102.3-105.4,102.5-106.1,102.5-106.9 M103.6-106.9 c0,1.1-0.3,1.9-0.9,2.6c-0.6,0.6-1.4,1-2.4,1c-1,0-1.8-0.3-2.4-1c-0.6-0.6-0.8-1.5-0.8-2.5c0-1.2,0.3-2.1,1-2.7 c0.6-0.6,1.4-0.9,2.4-0.9s1.8,0.3,2.3,0.9C103.3-108.9,103.6-108,103.6-106.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M108.9-105.3c0,0.5-0.2,1-0.6,1.4c-0.5,0.4-1.1,0.6-1.8,0.6c-0.6,0-1.2-0.1-1.7-0.4v-1.2 c0.5,0.4,1.1,0.6,1.7,0.6c0.8,0,1.3-0.3,1.3-0.9c0-0.3-0.1-0.5-0.3-0.6c-0.2-0.2-0.5-0.4-1.1-0.6c-0.5-0.2-1-0.5-1.2-0.8 c-0.3-0.3-0.4-0.7-0.4-1.2c0-0.5,0.2-1,0.7-1.4c0.5-0.4,1-0.5,1.7-0.5c0.5,0,1,0.1,1.4,0.3v1.1c-0.5-0.3-0.9-0.5-1.5-0.5 c-0.4,0-0.6,0.1-0.8,0.3c-0.2,0.2-0.3,0.4-0.3,0.7c0,0.3,0.1,0.5,0.3,0.7c0.2,0.2,0.5,0.3,1,0.5c0.6,0.2,1,0.5,1.2,0.7 C108.7-106.2,108.9-105.8,108.9-105.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M115.5-106.9c0-0.8-0.2-1.5-0.6-2c-0.4-0.4-0.9-0.6-1.6-0.6c-0.7,0-1.2,0.2-1.6,0.7c-0.4,0.5-0.6,1.1-0.6,2 c0,0.8,0.2,1.4,0.6,1.9c0.4,0.5,0.9,0.7,1.6,0.7s1.2-0.2,1.6-0.7C115.3-105.4,115.5-106.1,115.5-106.9 M116.6-106.9 c0,1.1-0.3,1.9-0.9,2.6c-0.6,0.6-1.4,1-2.4,1s-1.8-0.3-2.4-1c-0.6-0.6-0.8-1.5-0.8-2.5c0-1.2,0.3-2.1,1-2.7 c0.6-0.6,1.4-0.9,2.4-0.9s1.8,0.3,2.3,0.9C116.3-108.9,116.6-108,116.6-106.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M121.3-112.5c-0.2-0.1-0.5-0.2-0.7-0.2c-0.8,0-1.1,0.5-1.1,1.4v1h1.6v0.9h-1.6v5.8h-1.1v-5.8h-1.2v-0.9h1.2 v-1.1c0-0.7,0.2-1.3,0.7-1.7c0.4-0.4,0.9-0.5,1.5-0.5c0.3,0,0.6,0,0.8,0.1L121.3-112.5L121.3-112.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M125.5-103.6c-0.2,0.2-0.6,0.2-1,0.2c-1.2,0-1.8-0.7-1.8-2v-3.9h-1.2v-0.9h1.2v-1.6c0.3-0.1,0.7-0.2,1.1-0.3 v2h1.7v0.9h-1.7v3.8c0,0.5,0.1,0.8,0.2,1c0.2,0.2,0.4,0.3,0.8,0.3c0.3,0,0.5-0.1,0.7-0.2L125.5-103.6L125.5-103.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 160.405063)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M99.5-123.3c0,0.5-0.2,0.9-0.5,1.2c-0.3,0.4-0.7,0.5-1.2,0.5c-0.5,0-0.9-0.2-1.2-0.5 c-0.3-0.4-0.5-0.8-0.5-1.2c0-0.5,0.2-0.9,0.5-1.2c0.3-0.3,0.7-0.5,1.2-0.5c0.5,0,0.9,0.2,1.2,0.5C99.3-124.2,99.5-123.8,99.5-123.3 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M121.3-121.9h-3.2l-11.5-17.8c-0.3-0.4-0.5-0.9-0.7-1.4h-0.1c0.1,0.5,0.1,1.5,0.1,3.1v16.2h-2.6v-22.4h3.4 l11.2,17.6c0.4,0.7,0.7,1.2,0.9,1.5h0.1c-0.1-0.6-0.2-1.7-0.2-3.3v-15.8h2.6L121.3-121.9L121.3-121.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M138.1-121.9h-11.9v-22.4h11.4v2.4h-8.7v7.5h8.1v2.4h-8.1v7.8h9.3L138.1-121.9L138.1-121.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M156.1-141.9h-6.4v20h-2.6v-20h-6.5v-2.4h15.5V-141.9L156.1-141.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotnet);
export default __webpack_public_path__ + "static/media/dotnet.5a7d4e97c8c767a7b33664c47a739c4a.svg";
export { ForwardRef as ReactComponent };